import { ICartEntry } from '@rbi-ctg/menu';

import { getItemOfferDiscount } from '../../../../../state/cart-store/loyalty-helpers';
import { priceForCartEntry } from '../../../../../utils';

interface PriceCalculationResult {
  finalItemPrice: number;
  originalPrice: number;
  isFree: boolean;
  shouldShowStrikeThrough: boolean;
}

export function calculateItemPrice(
  item: ICartEntry,
  selectedOffer: any,
  offerEligibleItem: any
): PriceCalculationResult {
  const originalPrice = priceForCartEntry(item);
  const isOfferEligibleItem = !!offerEligibleItem;

  let finalItemPrice = originalPrice;

  // Apply item level offer discount
  if (isOfferEligibleItem) {
    const offerDiscount = getItemOfferDiscount({
      cartEntry: item,
      offer: selectedOffer,
      eligibleItem: offerEligibleItem,
    });
    finalItemPrice = finalItemPrice - offerDiscount;
  }

  const isFree = finalItemPrice === 0;
  const shouldShowStrikeThrough = isFree || isOfferEligibleItem;

  return {
    finalItemPrice,
    originalPrice,
    isFree,
    shouldShowStrikeThrough,
  };
}
